// Skeleton-Bausteine gegen Spinner-Flackern + Layout-Sprung (CLS).
// Nutzen animate-pulse + Theme-Neutraltoene · funktionieren in Light & Dark.

export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`animate-pulse rounded-md bg-slate-500/15 ${className}`} />;
}

/** Mehrere Textzeilen · letzte Zeile kuerzer (natuerlicher). */
export function SkeletonText({ lines = 3, className = '' }: { lines?: number; className?: string }) {
  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={`h-3.5 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`} />
      ))}
    </div>
  );
}

/** Karten-Platzhalter · Titelzeile + Textblock. */
export function SkeletonCard({ className = '' }: { className?: string }) {
  return (
    <div className={`rounded-2xl border border-border-primary p-5 ${className}`}>
      <div className="flex items-center gap-3 mb-4">
        <Skeleton className="w-10 h-10 rounded-full" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-3.5 w-1/3" />
          <Skeleton className="h-3 w-1/4" />
        </div>
      </div>
      <SkeletonText lines={3} />
    </div>
  );
}

/** Listen-/Tabellen-Platzhalter · n Zeilen. */
export function SkeletonList({ rows = 6, className = '' }: { rows?: number; className?: string }) {
  return (
    <div className={`space-y-2.5 ${className}`}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 rounded-xl border border-border-primary p-3.5">
          <Skeleton className="w-9 h-9 rounded-full shrink-0" />
          <Skeleton className="h-3.5 flex-1" />
          <Skeleton className="h-3.5 w-16 shrink-0" />
        </div>
      ))}
    </div>
  );
}

// Nutzt exakt die Karten-Sprache der echten App-Seiten (TopKpis + Inhaltskarten),
// damit der Ladezustand aussieht wie die Seite, die gleich kommt — nicht wie eine
// generische Liste. Der echte PageHeader wird von der Shell waehrend des Ladens
// bereits gezeigt, deshalb beginnt das Skeleton direkt mit dem Inhalt.

/** KPI-Kachel wie in TopKpis (Icon-Kachel + Label + grosse Zahl). */
function KpiTileSkeleton() {
  return (
    <div className="bg-bg-surface border border-slate-800 rounded-2xl p-5">
      <div className="flex items-center gap-2 mb-3">
        <Skeleton className="w-8 h-8 rounded-lg shrink-0" />
        <Skeleton className="h-2.5 flex-1" />
      </div>
      <Skeleton className="h-7 w-2/3" />
    </div>
  );
}

/** Inhalts-Platzhalter im App-Look: KPI-Reihe + Inhaltskarten + breite Tabellenkarte. */
export function PageSkeleton() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <KpiTileSkeleton key={i} />
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className="bg-bg-surface border border-slate-800 rounded-2xl p-5">
            <Skeleton className="h-4 w-1/3 mb-4" />
            <SkeletonText lines={4} />
          </div>
        ))}
      </div>

      <div className="bg-bg-surface border border-slate-800 rounded-2xl p-5">
        <Skeleton className="h-4 w-1/4 mb-4" />
        <div className="space-y-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3">
              <Skeleton className="w-9 h-9 rounded-full shrink-0" />
              <div className="flex-1 space-y-1.5">
                <Skeleton className="h-3 w-1/3" />
                <Skeleton className="h-2.5 w-1/2" />
              </div>
              <Skeleton className="h-3.5 w-20 shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
